'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-3';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0f0';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zm176-88c0-4.4 3.6-8 8-8l76 0c28.7 0 52 23.3 52 52 0 18.5-9.7 34.8-24.3 44 14.6 9.2 24.3 25.5 24.3 44 0 28.7-23.3 52-52 52l-76 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l76 0c19.9 0 36-16.1 36-36s-16.1-36-36-36l-60 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l60 0c19.9 0 36-16.1 36-36s-16.1-36-36-36l-76 0c-4.4 0-8-3.6-8-8z', 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm20-264l-60 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l60 0c19.9 0 36 16.1 36 36s-16.1 36-36 36l-76 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l76 0c28.7 0 52-23.3 52-52 0-18.5-9.7-34.8-24.3-44 14.6-9.2 24.3-25.5 24.3-44 0-28.7-23.3-52-52-52l-76 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l76 0c19.9 0 36 16.1 36 36s-16.1 36-36 36z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle3 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;